function isOverflow(element: Element) {
    return element?.clientWidth < element?.scrollWidth;
}

export const filterTooltipUtils = {
    isOverflow
}
